import React from 'react'
import { FormattedMessage } from 'react-intl'
import BEM from '@iui-kit/utils/bem'
import CustomPopper from '../Popper'
import cardPreviewDesktop from '@src/static/img/card-desktop.png'
import cardPreviewMobile from '@src/static/img/card-mobile.png'

const bem = new BEM(require('./CardExample.css'))

const CardExample: React.FC<{}> = () => {
  const desktop = <img width="500" src={cardPreviewDesktop} alt="card" />
  const mobile = <img width="293" src={cardPreviewMobile} alt="card" />

  return (
    <div className={bem.b('CardExample').show()}>
      <FormattedMessage
        id="Brief.search.step.cardExample"
        values={{
          desktop: (
            <CustomPopper placement="bottom" tooltip={desktop}>
              <span
                className={bem
                  .b('CardExample')
                  .e('link')
                  .show()}
              >
                <FormattedMessage id="Brief.search.step.cardExample.desktop" />
              </span>
            </CustomPopper>
          ),
          mobile: (
            <CustomPopper placement="bottom" tooltip={mobile}>
              <span
                className={bem
                  .b('CardExample')
                  .e('link')
                  .show()}
              >
                <FormattedMessage id="Brief.search.step.cardExample.mobile" />
              </span>
            </CustomPopper>
          )
        }}
      />
    </div>
  )
}

export default CardExample
